<section class="page-header">
  <div class="title-container">
    <h1>{{ "translate.general.reports" | translate }}</h1>
  </div>
</section>
<div class="header-actions">
  <button class="t-button-outline" (click)="addReport()">
    {{ "translate.mng.addReport" | translate }}
  </button>
</div>
<loader *ngIf="!reportsList || loading"></loader>

<ui-table
  [isWrapped]="false"
  [data]="reportsList"
  [numberOfRows]="10"
  [displayFilter]="['id', 'reportName']"
  [templates]="[
    {
      title: 'translate.general.executedOn',
      template: executedOn
    },
    {
      title: 'translate.general.executedBy.usrDescr',
      template: userDescription

    },
    {
      title: 'translate.general.startDate',
      template: startDate
    },
    {
      title: 'translate.general.endDate',
      template: endDate
    },
    {
      title: 'translate.general.actions',
      template: actions
    }
  ]"
></ui-table>
<ng-template #executedOn let-row="row">
  {{ formatDate(row.executedOn) || "-" }} 
</ng-template>
<ng-template #startDate let-row="row">
  {{ formatDateOnly(row.startDate) || "-" }} <!--Display date in format 'dd/MM/yyyy time' -->
</ng-template>
<ng-template #endDate let-row="row">
  {{ formatDateOnly(row.endDate) || "-" }} <!--Display date in format 'dd/MM/yyyy time' -->
</ng-template>
<ng-template #userDescription let-row="row">
  {{ row.executedBy?.usrDescr || "-" }} 
</ng-template>
<ng-template #actions let-row="row">
  <a (click)="download(row)">{{ "translate.general.download" | translate }}</a>

</ng-template>

<edit-report
  *ngIf="showEditReportModal"
  #editReportModal
  [report]="reportToSave"
  (onSave)="savedReport($event)"
  (onClose)="showEditReportModal = false; reportToSave = null;"
/>